export enum FormState {
    Initial = "Initial",
    Submitting = "Submitting",
    Success = "Success",
    Failure = "Failure",
  }